import React, {useEffect, useState} from "react";
import {Fields, Form, SelectBlock} from "../../components/Form/Form";
import {useParams} from "react-router-dom";
import SpotGroupOccupancy from "../../components/SpotGroupOccupancy/SpotGroupOccupancy";
import industries from "../../data/industries";
import useSpotGroupService from "../../api/services/useSpotGroupService";
import useBookableService from "../../api/services/useBookableService";
import Availabilities from "../../components/Form/Availabilities";
import useSpotService from "../../api/services/useSpotService";
import ProfileStatus from "../../components/ProfileStatus/ProfileStatus";
import SpotMapPublic from "../../components/SpotMap/SpotMapPublic";
import SpotPopup from "../../components/SpotPopup/SpotPopup";
import useForm from "../../hooks/useForm";
import Loading from "../../components/Loading/Loading";
import Button from "../../components/Button/Button";
import Popup from "../../components/Popup/Popup";
import swal from "sweetalert";
import Three from "../../components/Form/Three";
import BookingsContainer from "../../components/BookingsContainer/BookingsContainer";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";
import useManager from "../../hooks/useManager";

const UserSpotGroupManager = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [spotGroup, setSpotGroup] = useState(null)
  const [bookings, setBookings] = useState(null)
  const spotGroupService = useSpotGroupService()
  const {spotGroupId} = useParams()
  const [isLoadingBookings, setIsLoadingBookings] = useState(false)
  const [showPopupSpot, setShowPopupSpot] = useState([])
  const today = new Date()
  const nextYear = new Date()
  nextYear.setFullYear(today.getFullYear() + 1)
  const [dates, setDates] = useState([today, nextYear])
  const {showBookableRangeBookings} = useBookableService()
  const [showPopupIndustry, setShowPopupIndustry] = useState([])
  const [showPopupAvailability, setShowPopupAvailability] = useState([])
  const {createDateRange} = useManager()

  useEffect(() => {
    spotGroupService.userShowManager(
      (spotGroup) => {
        setSpotGroup({...spotGroup, bookings: []})
        handleCalendarChange([today, nextYear])
        setIsLoading(false)
      },
      (error) => {
        console.error('validation errors', error)
        //todo do something
        setIsLoading(false)
      },
      spotGroupId,
    )
  }, [])

  /**
   *
   * @param dates
   */
  const handleCalendarChange = (dates) => {
    setDates(dates)
    if (dates.length === 2) {
      setIsLoadingBookings(true)
      showBookableRangeBookings(
        (bookings) => {
          setBookings(bookings)
          setIsLoadingBookings(false)
        },
        (error) => {
          setIsLoadingBookings(false)
        },
        'spot_group',
        spotGroupId,
        typeof dates[0].toDate === "function" ? dates[0].toDate() : dates[0],
        typeof dates[1].toDate === "function" ? dates[1].toDate() : dates[1],
      )
    }
  }

  return (
    <div className="component-spot-group-manager">
      <div className="row">
        <div className="col">
          <h1>Locatiebeheer</h1>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup
            location="/user/locatie/{id}/manager"
          />
        </div>
      </div>

      {isLoading ?
        <Loading/>
        :
        <>
          {spotGroup &&
            <>
              Locatie: {spotGroup.label}
              <ProfileStatus
                model={spotGroup}
                showSettingButton={true}
              />
              <h3>Beschikbaarheid komende jaar</h3>
              <SpotGroupOccupancy
                spotGroup={spotGroup}
                createDateRange={createDateRange}
              />
              <br/>
              <div className="spot-map">
                {spotGroup.multi_spot ?
                  <>
                    {spotGroup.show_spots_as_list
                      ? <>

                      </>
                      : <>
                        <SpotMapPublic
                          spotGroup={spotGroup}
                          onSpotClick={(booking, setBooking, spot) => {
                            swal({
                              title: 'Instellingen',
                              text: null,
                              icon: null,
                              buttons: {
                                confirmA: {
                                  text: 'Beschikbaarheid',
                                  value: 'availability',
                                  className: 'btn-color-grey btn-size-m',
                                },
                                confirmB: {
                                  text: 'Branches',
                                  value: 'industry',
                                  className: 'btn-color-grey btn-size-m',
                                }
                              }
                            }).then((result) => {
                              if (result) {
                                if (result === 'availability') {
                                  setShowPopupAvailability({...showPopupAvailability, [spot.id]: true})
                                }
                                if (result === 'industry') {
                                  setShowPopupIndustry({...showPopupIndustry, [spot.id]: true})
                                }
                              }
                            })
                          }}
                          // onAddSpotListClick={(booking, setBooking, availableSpots) => {
                          //   addAvailableSpotToBooking(booking, setBooking, availableSpots)
                          // }}
                          // onRemoveSpotListClick={(booking, setBooking) => {
                          //   removeSpotsFromBookings(booking, setBooking)
                          // }}
                          booking={{
                            dates: createDateRange(dates),
                            spots: []
                          }}
                        />
                        {spotGroup.spots.map((spot, i) => {
                          return (
                            <div key={i}>
                              <SpotPopups
                                spot={spot}
                                spotGroup={spotGroup}
                                setSpotGroup={setSpotGroup}
                                setShowPopupAvailability={
                                  (bool) => {
                                    setShowPopupAvailability({...showPopupAvailability, [spot.id]: bool})
                                  }}
                                setShowPopupIndustry={
                                  (bool) => setShowPopupIndustry({...showPopupIndustry, [spot.id]: bool})
                                }
                                showPopupAvailability={showPopupAvailability[spot.id]}
                                showPopupIndustry={showPopupIndustry[spot.id]}
                              />
                            </div>
                          )
                        })}
                      </>
                    }

                  </>
                  :
                  <>
                    <Button
                      label="Meer info over deze standplaats"
                      onClick={() => setShowPopupSpot({...showPopupSpot, [0]: true})}
                      color="grey"
                    />
                    <SpotPopup
                      spot={spotGroup.spots[0]}
                      iteration={0}
                      setShowPopupSpot={setShowPopupSpot}
                      showPopupSpot={showPopupSpot}
                    />
                  </>
                }
              </div>

              <h3>Boekingen in geselecteerde periode</h3>
              <BookingsContainer
                bookings={bookings}
                handleCalendarChange={handleCalendarChange}
                dates={dates}
                isLoading={isLoadingBookings}
              />
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
            </>
          }
        </>
      }

    </div>
  )
}

const SpotPopups = ({
                      spot,
                      spotGroup,
                      setSpotGroup,
                      showPopupAvailability,
                      setShowPopupAvailability,
                      showPopupIndustry,
                      setShowPopupIndustry,
                    }) => {

  const form = useForm()
  const spotService = useSpotService()
  return (
    <>
      <Popup
        showPopup={showPopupAvailability}
        setShowPopup={setShowPopupAvailability}
        title="Beschikbaarheid"
      >
        <Form>
          <Fields
            id={spot.id}
            onRender={(form) => {
              //force showing save buttons by setting 'isChanged' to true
              form.save(true)
            }}
            form={form}
            apiService={spotService}
            onReset={() => {
              setShowPopupAvailability(false)
            }}
            updateSuccess={(newSpot) => {
              setShowPopupAvailability(false)
              spotGroup.spots.map((spot, i) => {
                if (spot.id === newSpot.id) {
                  spotGroup.spots[i] = newSpot
                }
                return spot
              })
              setSpotGroup(spotGroup)
            }}
          >
            <Three
              label="Wat is de status van deze standplaats?"
              name="available"
              labelYes="Elke dag beschikbaar"
              labelNo="(nog) niet beschikbaar (niet boekbaar en niet in zoekresultaten)"
              labelOther="Specifieke dag(en) ingeven"
            />
            <Availabilities
              label="Beschikbaarheid specifiek voor deze standplaats/grondplaats"
              name="availabilities"
              enabledBy={[{key: 'available', value: 2}]}
            />
          </Fields>
        </Form>
      </Popup>
      <Popup
        showPopup={showPopupIndustry}
        setShowPopup={setShowPopupIndustry}
        title="Branches"
      >
        <Form>
          <Fields
            id={spot.id}
            onRender={(form) => {
              //force showing save buttons by setting 'isChanged' to true
              form.save(true)
            }}
            form={form}
            apiService={spotService}
            onReset={() => {
              setShowPopupIndustry(false)
            }}
            updateSuccess={(newSpot) => {
              setShowPopupIndustry(false)
              spotGroup.spots.map((spot, i) => {
                if (spot.id === newSpot.id) {
                  spotGroup.spots[i] = newSpot
                }
                return spot
              })
              setSpotGroup(spotGroup)
            }}
          >
            <p>{spot.id}</p>
            <SelectBlock
              label="Vink aan in welke branche jij valt met jouw stand of truck: (je kunt meerdere vakjes aankruisen)"
              name="industries_ids"
              data={industries}
            />
          </Fields>
        </Form>

      </Popup>
    </>
  )

}


export default UserSpotGroupManager
